import React from "react";
import {
  BottomNavigation,
  BottomNavigationAction,
  Hidden,
  Badge,
} from "@material-ui/core";
import AssignmentIcon from "@material-ui/icons/Assignment";
import AddIcon from "@material-ui/icons/Add";
import HistoryIcon from "@material-ui/icons/History";
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import LoopIcon from '@material-ui/icons/Loop';
import SettingsIcon from '@material-ui/icons/Settings';
import PeopleIcon from '@material-ui/icons/People';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import AcompanamientoNotificaciones from './AcompanamientoNotificaciones';

const clase = (item, selec, tipo = "") =>
  item === selec ? `item_selec${tipo}` : `item_modulo`;

function MenuAcompanamiento({ sele = "nuevo", seleccionar = () => {}, notificaciones = [] }) {
  const pintar = (app, claseN = "") => {
    if (!app) {
      return (
        <div className={claseN}>
          <BottomNavigation
            showLabels
            className={clase("procesos", sele)}
            onClick={() => seleccionar("procesos")}
          >
            <BottomNavigationAction
              label={"Procesos"}
              icon={<AssignmentIcon />}
            />
          </BottomNavigation>

          <AcompanamientoNotificaciones 
            notificaciones={notificaciones} 
            render={(click) => 
              <BottomNavigation 
                showLabels 
                onClick={click} 
                className={clase('notificaciones', sele)}
              >
                <BottomNavigationAction 
                  label={'Notificaciones'} 
                  icon={
                    <Badge badgeContent={notificaciones.length} color="secondary">
                      <NotificationImportantIcon />
                    </Badge>
                  } 
                />
              </BottomNavigation>
            } 
          />

          <BottomNavigation
            showLabels
            className={clase("nuevo", sele)}
            onClick={() => seleccionar("nuevo")}
          >
            <BottomNavigationAction
              label={"Nuevo"}
              icon={<AddIcon />}
            />
          </BottomNavigation>

          <BottomNavigation
            showLabels
            className={clase("historial", sele)}
            onClick={() => seleccionar("historial")}
          >
            <BottomNavigationAction
              label={"Historial"}
              icon={<HistoryIcon />}
            />
          </BottomNavigation>
        </div>
      );
    } else {
      return (
        <div className={claseN}>
          <BottomNavigation showLabels>
            <BottomNavigationAction
              label={"Procesos"}
              icon={<AssignmentIcon />}
              className={clase("procesos", sele, "_app")}
              onClick={() => seleccionar("procesos")}
            />
            <AcompanamientoNotificaciones 
              notificaciones={notificaciones} 
              horizontal='left'
              render={(click) => 
                <BottomNavigationAction
                  onClick={click}
                  label={'Notificaciones'}
                  icon={
                    <Badge badgeContent={notificaciones.length} color="secondary">
                      <NotificationImportantIcon />
                    </Badge>
                  }
                  className={clase('notificaciones', sele, '_app')}
                />
              } 
            />
            <BottomNavigationAction
              label={"Nuevo"}
              icon={<AddIcon />}
              className={clase("nuevo", sele, "_app")}
              onClick={() => seleccionar("nuevo")}
            />
            <BottomNavigationAction
              label={"Historial"}
              icon={<HistoryIcon />}
              className={clase("historial", sele, "_app")}
              onClick={() => seleccionar("historial")}
            />
          </BottomNavigation>
        </div>
      );
    }
  };

  return (
    <div>
      <Hidden xsDown>{pintar(false, "menu_modulo")}</Hidden>
      <Hidden smUp>{pintar(true, "menu_modulo_app")}</Hidden>
    </div>
  );
}

// Función para el menú de detalle (Detalle, Estado y Estudiantes)
export function AcompanamientoMenu({ sele = 0, seleccionar = () => { } }) {
  const pintar = (claseN = '') => {
    return (
      <div className={claseN}>
        <BottomNavigation showLabels >
          <BottomNavigationAction label={'Detalle'} icon={<ImportContactsIcon />} className={clase('detalle', sele)} onClick={() => seleccionar('detalle')} />
          <BottomNavigationAction label={'Estudiantes'} icon={<PeopleIcon />} className={clase('estudiantes', sele)} onClick={() => seleccionar('estudiantes')} />
          <BottomNavigationAction label={'Estado'} icon={<LoopIcon />} className={clase('estado', sele)} onClick={() => seleccionar('estado')} />
        </BottomNavigation>
      </div>
    )
  }

  return pintar('menu_modal');
}

// Función para el menú de administrar (Procesos, Administrar y Nuevo)
export function MenuAdministrar({ sele = "procesos", seleccionar = () => {} }) {
  const pintar = (app, claseN = "") => {
    if (!app) {
      return (
        <div className={claseN}>
          <BottomNavigation
            showLabels
            className={clase("procesos", sele)}
            onClick={() => seleccionar("procesos")}
          >
            <BottomNavigationAction
              label={"Procesos"}
              icon={<AssignmentIcon />}
            />
          </BottomNavigation>

          <BottomNavigation
            showLabels
            className={clase("administrar", sele)}
            onClick={() => seleccionar("administrar")}
          >
            <BottomNavigationAction
              label={"Administrar"}
              icon={<SettingsIcon />}
            />
          </BottomNavigation>

          <BottomNavigation
            showLabels
            className={clase("nuevo", sele)}
            onClick={() => seleccionar("nuevo")}
          >
            <BottomNavigationAction
              label={"Nuevo"}
              icon={<AddIcon />}
            />
          </BottomNavigation>
        </div>
      );
    } else {
      return (
        <div className={claseN}>
          <BottomNavigation showLabels>
            <BottomNavigationAction
              label={"Procesos"}
              icon={<AssignmentIcon />}
              className={clase("procesos", sele, "_app")}
              onClick={() => seleccionar("procesos")}
            />
            <BottomNavigationAction
              label={"Administrar"}
              icon={<SettingsIcon />}
              className={clase("administrar", sele, "_app")}
              onClick={() => seleccionar("administrar")}
            />
            <BottomNavigationAction
              label={"Nuevo"}
              icon={<AddIcon />}
              className={clase("nuevo", sele, "_app")}
              onClick={() => seleccionar("nuevo")}
            />
          </BottomNavigation>
        </div>
      );
    }
  };

  return (
    <div>
      <Hidden xsDown>{pintar(false, "menu_modulo")}</Hidden>
      <Hidden smUp>{pintar(true, "menu_modulo_app")}</Hidden>
    </div>
  );
}

export default MenuAcompanamiento;